import { Rule } from 'antd/es/form';

export enum FORM_FIELD {
  NAME = 'name',
  DESCRIPTION = 'description',
  START_FROM = 'startFrom',
  END_TO = 'endTo',
}

export const FormLabel: Partial<Record<FORM_FIELD, string>> = {
  [FORM_FIELD.NAME]: 'Tên cao điểm',
  [FORM_FIELD.DESCRIPTION]: 'Mô tả',
  [FORM_FIELD.START_FROM]: 'Ngày bắt đầu',
  [FORM_FIELD.END_TO]: 'Ngày kết thúc',
};

export const FormValidation: Partial<Record<FORM_FIELD, Rule[]>> = {
  [FORM_FIELD.NAME]: [{ required: true, message: 'Hãy nhập tên cao điểm bán' }],
  [FORM_FIELD.START_FROM]: [
    { required: true, message: 'Hãy chọn ngày bắt đầu' },
  ],
  [FORM_FIELD.END_TO]: [{ required: true, message: 'Hãy chọn ngày kết thúc' }],
};
